import { Feedback, formatPercent, getRandomKey, isArrayItem } from "shelving";
import { PUBLISH_MEDIA } from "shared/api";
import { uploadStorageFile } from "shared/firebase/storage";
import { NOTICES } from "shared/react";
import { MEDIA_TYPES, MEDIA_UPLOAD_BUCKET_NAME, MEDIA_UPLOAD_MAX } from "shared/util/media";
import { callAPI } from "./api.js";
import { USER } from "./user.js";

/** Upload a file to the media uploads bucket, call the `publishMedia` API method, and show a loading notice while it happens. */
export async function uploadMediaFile(file: File): Promise<string> {
	const notice = NOTICES.load();
	try {
		if (file.size > MEDIA_UPLOAD_MAX * 1024 * 1024) throw new Feedback(`Maximum size ${MEDIA_UPLOAD_MAX} MB`);
		if (!isArrayItem(Object.values(MEDIA_TYPES), file.type)) throw new Feedback("Invalid file type");
		const uploadPath = `${USER.data.uid}/${getRandomKey()}`;
		await uploadStorageFile(file, `gs://${MEDIA_UPLOAD_BUCKET_NAME}/${uploadPath}`, (progress, total) => notice.load(`${formatPercent(progress, total)} uploaded...`));
		notice.load("Processing...");
		const publishPath = await callAPI(PUBLISH_MEDIA, uploadPath);
		notice.close();
		return publishPath;
	} catch (thrown) {
		notice.error(thrown instanceof Feedback ? thrown.message : "Upload error");
		throw thrown;
	}
}
